module.exports = __webpack_public_path__ + "static/img/图片22.dd4cf419.png";